import { createWorkflow as postCreateWorkflow } from '~/api/workflows';

export const createWorkflow = async (
  workflow: Parameters<typeof postCreateWorkflow>[0],
) => {
  return postCreateWorkflow(workflow);
};
